export default {
  color: {
    background: "#FFFDF6",
    primary: "#245FB8",
    secondary: "#F0F6FC",
  },
};
